import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RandomRouteComponent.css';

export default function RandomRouteComponent() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/');
  };
  return (
    <>
      <Box
        sx={{
          height: '80%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h5"
          component="h3"
          align="center"
          color={'#36454F'}
        >
          It seems like you're lost, please select a valid route.
        </Typography>

        <Button
          sx={{ mt: '15px', height: '35px', alignSelf: 'center' }}
          variant="contained"
          color="primary"
          onClick={handleClick}
        >
          Home Page
        </Button>
      </Box>
    </>
  );
}
